import Component from "./LabelCellAsFirstColumn";
export default Component;
